<div class="grid">
  <div class="card g-col-12">
    <div class="card-body grid">
      <div class="d-flex flex-column g-col-6"><kendo-formfield showHints="initial" showErrors="initial">
        <kendo-label
          labelCssClass="k-form-label"
          [for]="client"
          [text]="'CLIENT' | translate | capitalize" />
          @let clients = clients$ | async;
          <kendo-combobox
            #client
            [data]="clients ?? []"
            [filterable]="true"
            [kendoDropDownFilter]="filterSettings"
            (filterChange)="onSearch($event, 'clients')"
            [textField]="'name'"
            [valueField]="'@id'"
            [valuePrimitive]="true"
            [placeholder]="'SELECT' | translate | capitalize"
            [(ngModel)]="selectedClient">
          </kendo-combobox>
        </kendo-formfield>
      </div>
    </div>
  </div>
</div>

<kendo-dialog-actions>
  <div class="d-flex justify-content-end gap-16">
    <button [type]="'submit'" kendoButton themeColor="primary" [iconClass]="'rc-icon-check'" [disabled]="!selectedClient" (click)="onSubmit()">
      {{ "SELECT" | translate | capitalize }}
    </button>
  </div>
</kendo-dialog-actions>
